<template>
	<div v-bind:class="['expr', op]">
		<div v-for="(term, index) in terms" :key="index">
			<template v-if="expressionPredicate(term)">
				<filter-expression
					v-model="term.predicate"
					@change="changed"
					@remove="removePredicate(index)">
				</filter-expression>
			</template>
			<template v-else-if="term.predicate">
				<Predicate
					v-model="term.predicate"
					@change="changed"
					@remove="removePredicate(index)">
				</Predicate>
			</template>
			<div class="divider"></div>
		</div>
		<el-button size="small" type="primary" plain
			@click="addPredicate">
			<i class="el-icon-plus"></i> &nbsp;&nbsp;<strong style="font-size:14px;">Add Condition</strong>
		</el-button>
	</div>
</template>

<script>
import Vue from 'vue'
const OPERATOR = ['and', 'or', 'ordered']

import Predicate from './Predicate'

export default {
	name: 'filter-expression',

	props: ['value'],

	computed: {
		op() {
			if (this.value && this.value.id[0] === 'logic')
				return this.value.id[1]
			return null
		},
		terms() {
			if (this.value)
				return this.value.term
			else
				return []
		}
	},

	methods: {
		changed() {
			this.$emit('value', this.value)
			this.$emit('change')
		},
		addPredicate() {
			if (! Array.isArray(this.value.term))
				Vue.set(this.value, 'term', [])
			this.value.term.push({
				predicate: {
					id: [],
					arg: null
				}
			})
			this.changed()
		},
		termKey(term, index) {
			return index + term.predicate.id.join('/')
		},
		expressionPredicate(term) {
			return term.predicate.id[0] === 'logic'
		},
		removePredicate(index) {
			this.value.term.splice(index, 1)
			this.changed()
		}
	},

	components: {
		Predicate
	}
}
</script>

<style lang="scss" scoped>
.and.expr::before {
	content: 'all of the following match'
}
.and.expr .divider::before {
	content: 'and'
}
.or.expr .divider::before {
	content: 'or'
}
.or.expr::before {
	content: 'any of the following match'
}
.expr::before {
	position: absolute;
	left: 10px;
	top: -2px;
	font-size: 16px;
	font-weight: 700;
	color: #355170;
	background: white;
	line-height: 2px;
	padding: 0 5px;
}
.expr {
	position: relative;
	border: solid 1px rgba(0, 0, 0, 0.06);
	background: rgba(0, 0, 0, 0.03);
	border-radius: 8px;
	padding: 15px 10px 10px 10px;
	margin-top: 10px;

	.divider {
		position: relative;
		display: block;
		background: rgba(0, 0, 0, 0.03);
		height: 2px;
		margin: 15px;
		font-size: 14px;
		font-weight: 500;
	}
	.divider::before {
		position: absolute;
		left: 0px;
		top: 0px;
		line-height: 2px;
		background: rgba(255, 255, 255, 0.5);
		text-align: center;
		padding: 0 15px 0 5px;
		color: lighten(#355170, 10%);
	}
}
</style>
